export default function Dmca() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <h1 className="text-3xl font-black text-fg mb-2">DMCA Policy</h1>
      <p className="text-sm text-muted mb-10">vaumanga.com</p>

      <div className="flex flex-col gap-8">
        <section className="flex flex-col gap-3">
          <div className="text-sm text-fg leading-relaxed flex flex-col gap-2">
            <p>vaumanga.com respects the intellectual property rights of others and expects its users to do the same. In accordance with the Digital Millennium Copyright Act (DMCA), we will respond to notices of alleged copyright infringement.</p>
            <p>If you believe your copyrighted work has been posted on our site without authorization, please send a written notice to: <a href="mailto:dmca@vaumanga.com" className="text-accent hover:underline">dmca@vaumanga.com</a></p>
          </div>
        </section>

        <Section title="Your notice must include">
          <ul>
            <li>Your full name and contact information (email, address, phone)</li>
            <li>Description of the copyrighted work you claim has been infringed</li>
            <li>The exact URL(s) on vaumanga.com where the infringing content is located</li>
            <li>A statement that you have a good faith belief that the use is not authorized by the copyright owner</li>
            <li>A statement that the information in your notice is accurate, and under penalty of perjury, that you are the copyright owner or authorized to act on their behalf</li>
            <li>Your electronic or physical signature</li>
          </ul>
        </Section>

        <Section title="We will">
          <ul>
            <li>Review your request within 3–5 business days</li>
            <li>Remove or disable access to the content if the claim is valid</li>
            <li>Notify the user who posted the content</li>
          </ul>
          <p>Repeat infringers will have their accounts terminated.</p>
        </Section>
      </div>
    </div>
  )
}

function Section({ title, children }) {
  return (
    <section className="flex flex-col gap-3">
      <h2 className="text-base font-bold text-accent">{title}</h2>
      <div className="flex flex-col gap-2 text-sm text-fg leading-relaxed [&_ul]:flex [&_ul]:flex-col [&_ul]:gap-1.5 [&_ul]:pl-1 [&_li]:flex [&_li]:gap-2 [&_li]:before:content-['—'] [&_li]:before:text-muted [&_li]:before:flex-shrink-0">
        {children}
      </div>
    </section>
  )
}
